import { render } from "./ExpertStatisticsDashboard.vue?vue&type=template&id=00597262"
import script from "./ExpertStatisticsDashboard.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsDashboard.vue?vue&type=script&lang=js"

import "./ExpertStatisticsDashboard.vue?vue&type=style&index=0&id=00597262&lang=css"
script.render = render

export default script